import AdvancedQuestionConfiguration from './AdvancedQuestionConfiguration'

import './style.scss'

export { AdvancedQuestionConfiguration }
export default AdvancedQuestionConfiguration
